import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { QueryBuilder } from '@/core/uql';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { stat } from 'fs';

interface LinesDetailsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;

    inWorkStatus: any;
    formationStatus: any;
    workers: any[];
    remains: any;
    meta: any;
}

const state: LinesDetailsState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,

    inWorkStatus: null,
    formationStatus: null,
    workers: [],
    remains: null,
    meta: {},
};

const initState: any = cloneDeep(state);

export const LINES_DATA = 'GET_LINES_DATA';
export const LOAD_LINES_PRODUCTS = 'LOAD_LINES_PRODUCTS';

export function shiftWorkers(docId: string) {
  return {
    columns: {
      id: 'sw.id',
      employee_name: 'employee.name',
      role_name: 'role.name',
      is_manager: 'role.is_manager',
      is_combined: 'sw.is_combined',
      combine_time: 'sw.combine_time',
    },

    from: 's:shift_workers',
    from_as: 'sw',
    page_size: 1000,
    joins: [
      {
        join: 's:employees',
        type: 'left',
        as:   'employee',
        on: {
          $eq: ['sw.employee_id', 'employee.id']
        }
      },
      {
        join: 's:voc_roles',
        type: 'left',
        as:   'role',
        on: {
          $eq: ['sw.role_id', 'role.id']
        }
      },
    ],
    order: [
      {$asc: ['sw.id']}
    ],
    where: {
      $eq: [`sw.shift_id`, {$: docId}]
    }
  }
}

export function shiftDetails(docId: string) {
  const columns: any = {
    id: 'line.id',
    name: 'line.name',
    templates: 'line.templates',
    volume_name: 'volumes.name',
  };

  return {
      columns,
      from: 's:voc_lines',
      from_as: 'line',
      joins: [
          {
            join: 's:voc_volumes',
            type: 'left',
            as:   'volumes',
            on: {
              $eq: ['line.volume_id', 'volumes.id']
            }
          },
       ],
      where: {
        $eq: [`line.id`, {$: docId}]
      }
  }
}

export const actions: ActionTree<LinesDetailsState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, params) {
        const vm = (this as any)._vm;

        console.log('params', params);

        if (params.id == 'new') {
            state.document = {};
            state.loaded = true
        } else {
            return new Promise((resolve, reject) => {
                if (!params.silence) {
                    commit('START_LOADING');
                }

                vm.$db([
                    vm.$q(LINES_DATA)
                      .raw('documents.list')
                      .action(shiftDetails(params.id)),
                ]).then(((result: ServerResult) => {
                    commit('SET_LINES_DATA', {
                      data: result.getOperation(LINES_DATA).getContent(),
                    });
                    if (!params.silence) {
                        commit('LOADED_SUCCESS');
                    }
                    resolve();
                }));
            })
        }
    },

};

export const mutations: MutationTree<LinesDetailsState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_LINES_DATA(state, {data}) {
      const schema = data.schema;
      const document = data.documents[0];

      console.log(schema, fetchEnumsFromSchema(schema))

      state.meta = fetchEnumsFromSchema(schema)

      state.document = document
  },

  SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
      state.inWorkStatus = inWorkStatus;
      state.formationStatus = formationStatus;
  },
};

export const getters: GetterTree<LinesDetailsState, RootState> = {
  canActionToWork: (state: LinesDetailsState) => {
      return state.document.pipeline_code === 'active' && state.document.status_code === 'new';
  },
  canActionConfirmAction: (state: LinesDetailsState) => {
      return (!!state.document.approve_by_id && state.document.approve_result === null);
  },
  disableActionConfirmActionCall: (state, getters, rootState) => {
      return !(state.document.approve_result === null && state.document.approve_by_id == (rootState as any).ubic.actor.document.id)
  },
  canActionToFormation: (state, getters, rootState) => {
      return !getters.canActionConfirmAction && (state.document.pipeline_code === 'active' && state.document.status_code === 'in_work');
  },
  hasActions: (state, getters, rootState) => {
      return getters.canActionToWork || getters.canActionConfirmAction || getters.canActionToFormation
  }
};

export const STORE_KEY = '$_lines_details';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
